<div class="values-area funfacts-area pt-3">
    <div class="funfacts-inner">
        <div class="conainer">

            <div class="row align-items-center">
                <div class="col-lg-3 col-md-3 col-6">
                    <div class="single-funfact">
                        <div class="icon">
                            <i class='bx bxs-notepad'></i>
                        </div>
                        <h3><span [countUp]="20">00</span></h3>
                        <p i18n>Articles</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-6">
                    <div class="single-funfact">
                        <div class="icon">
                            <i class='bx bx-building-house'></i>
                        </div>
                        <h3><span [countUp]="3">00</span></h3>
                        <p i18n>Projects</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-6">
                    <div class="single-funfact">
                        <div class="icon">
                            <i class='bx bx-video-recording'></i>
                        </div>
                        <h3><span [countUp]="90">00</span></h3>
                        <p i18n>Video and Audio</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-6">
                    <div class="single-funfact">
                        <div class="icon">
                            <i class='bx bx-book-reader'></i>
                        </div>
                        <h3><span [countUp]="5">00</span></h3>
                        <p i18n>Books</p>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>

<div class="values-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-12">
                <div class="section-title text-start">
                    <h3 i18n>Our Mission & Vision</h3>
                    <img src="assets/img/logo.png" style="max-height:20em">
                </div>
            </div>
            <div class="col-lg-8 col-md-12">
                <div class="story-content" *ngIf="visions">
                    <div *ngFor="let vision of visions" class="pt-4">
                        <h4>{{vision?.title}}</h4>
                        <p>{{vision?.text}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>